module.exports = {
  UNSPECIFIED: 'unspecified',
  FIRST_CONTACT: 'first contact',
  REVOLUTION: 'revolution',
  EXPANSION: 'claim',
  ACCOMPLISHMENT: 'advance',
  RELATIONSHIP: 'relationship',
  UPDATE_PLAYER: 'updatePlayer'
};
